
export default function CommonQuestions() {
  const questions = [
    {
      question: 'Do you have MFA enabled for all email, remote access, and administrative accounts?',
      risk: 'high'
    },
    {
      question: 'Are backups encrypted, isolated, and protected from modification or deletion?',
      risk: 'high'
    },
    {
      question: 'How frequently are operating systems, applications, and firmware patched?',
      risk: 'high'
    },
    {
      question: 'Do you maintain a written incident response plan, and has it been tested or tabletop-exercised?',
      risk: 'medium'
    },
    {
      question: 'Have you experienced any cyber incidents, ransomware events, or data breaches in the past 2–3 years?',
      risk: 'high'
    },
    {
      question: 'Do you restrict and regularly review administrative privileges, including local admin access?',
      risk: 'medium'
    },
    {
      question: 'Is endpoint security centrally managed and monitored?',
      risk: 'high'
    },
    {
      question: 'Do you log and retain security events, and are logs reviewed regularly?',
      risk: 'medium'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Common Questions Asked by Cyber Insurers
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            You can expect insurers to ask questions such as:
          </p>
        </div>

        <div className="space-y-4">
          {questions.map((item, index) => (
            <div 
              key={index}
              className={`bg-gradient-to-r ${
                item.risk === 'high' 
                  ? 'from-red-50 to-orange-50 border-red-200' 
                  : 'from-yellow-50 to-amber-50 border-yellow-200'
              } rounded-xl p-6 border-2 hover:shadow-lg transition-all`}
            >
              <div className="flex items-start gap-4">
                <div className={`flex-shrink-0 w-10 h-10 ${
                  item.risk === 'high' 
                    ? 'bg-red-600' 
                    : 'bg-yellow-600'
                } rounded-lg flex items-center justify-center`}>
                  <span className="text-white font-bold text-lg">{index + 1}</span>
                </div>
                
                <div className="flex-1">
                  <p className="text-lg text-gray-900 font-medium leading-relaxed">
                    {item.question}
                  </p>
                  
                  {item.risk === 'high' && (
                    <div className="mt-3 inline-flex items-center gap-2 bg-red-100 px-3 py-1 rounded-full">
                      <i className="ri-alert-fill text-red-600"></i>
                      <span className="text-sm font-semibold text-red-700">High Impact Question</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-red-50 border-l-4 border-[#e10708] p-8 rounded-lg">
          <div className="flex items-start gap-4">
            <i className="ri-information-line text-3xl text-[#e10708] flex-shrink-0"></i>
            <div>
              <h3 className="text-xl font-bold text-red-900 mb-2">Important Note</h3>
              <p className="text-red-800 leading-relaxed">
                If you answer "no" to any of these questions and do not have the controls in place, it could lead to <strong>denied claims</strong> or <strong>coverage exclusions</strong> when you need protection most.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}